import { render } from "./AssignmentView.vue?vue&type=template&id=29698d99"
import script from "./AssignmentView.vue?vue&type=script&lang=js"
export * from "./AssignmentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__